// Trouble Signing In Alpine.js Component
// Reusable component for password reset, confirmation, and unlock pages

document.addEventListener('alpine:init', () => {
  // Generic trouble signing in component
  Alpine.data('troubleSignin', (pageType = 'password') => ({
    // Email validation state
    email: '',
    emailValid: true,
    emailTouched: false,
    emailFocused: false,
    selectedIssue: '',
    pageType: pageType, // 'password', 'confirmation', or 'unlock'

    // Simple email validation regex
    emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,

    // Get button text based on page type
    getButtonText() {
      const config = window.TroubleSigninConfig;
      if (!config) return '';

      // Return button text based on current page type
      if (this.pageType === 'password') {
        return config.i18n.btnSendPasswordReset;
      }

      if (this.pageType === 'confirmation') {
        return config.i18n.btnResendConfirmation;
      }

      if (this.pageType === 'unlock') {
        return config.i18n.btnResendUnlock;
      }

      return '';
    },

    // Email validation methods
    isEmailValid() {
      return this.email.trim() !== '' && this.emailRegex.test(this.email);
    },

    validateEmail() {
      // Don't show error if email is empty
      if (this.email.trim() === '') {
        this.emailValid = true;
        return;
      }
      this.emailValid = this.emailRegex.test(this.email);
    },

    validateEmailDebounced() {
      window.ValidationUtils.debounce('email-validation', () => {
        this.emailTouched = true;
        this.validateEmail();
      }, window.ValidationUtils.constants.DEBOUNCE_DELAY);
    },

    validateEmailOnBlur() {
      this.emailFocused = false;
      this.emailTouched = true;
      window.ValidationUtils.clearTimer('email-validation');
      setTimeout(() => {
        this.validateEmail();
      }, window.ValidationUtils.constants.BLUR_DELAY);
    },

    onEmailFocus() {
      this.emailFocused = true;
    },

    shouldShowEmailError() {
      // Don't show error when field is focused or empty
      return !this.emailValid && this.emailTouched && !this.emailFocused;
    },

    isSubmitDisabled() {
      return !this.isEmailValid();
    },

    init() {
      // Initialize email from field if pre-filled or from URL params
      const emailField = document.getElementById('user_email');
      if (emailField && emailField.value) {
        this.email = emailField.value;
      }

      // Set selectedIssue based on page type
      // This maps page types to their corresponding issue types for the dropdown
      const issueMapping = {
        'password': 'reset-password',
        'confirmation': 'confirmation-email',
        'unlock': 'unlock-account'
      };

      this.selectedIssue = issueMapping[this.pageType] || this.pageType;
    }
  }));
});
